import React, {Component} from "react";
import AllScansView from "./dashboard";
import "../asset/style/morpheus.css"
import logo_full from "../asset/img/logo-mp.png"
import logo_square from "../asset/img/logo_square.png"
import { Layout, Menu, Icon, Row, Col, Affix, Spin, Button, Modal, Input } from 'antd';
import {Link} from 'react-router-dom';
import ScannersListComp from "../component/dashboard/scannerspane";
import {SyncViewerView } from '../view/sync-viewer'
import { PrivateRoute } from '../helper/private.route';
import ScannerView from '../view/scanner';
import CategoryView from '../view/category';
import CaseListView from '../view/caselist';
import { CaseView } from '../view/caseview';
import ClassifierUI from '../component/viewer/classifierView';
import { TuningView } from './tuning'
import { historyMP } from '../helper/history';
import { connect } from "react-redux";
import { logout } from "../action/login.action";
import 'antd/dist/antd.css';
import { closeDrawer, openDrawer } from "../action/dashboard.action";
import cookie from "react-cookies";
import { urls } from "../helper/backend.urls";
import { globalUrlPrefix } from '../utils/const'
import OldScan from '../view/oldscan';
import StatsDashboard from './statsDashboard';

const { SubMenu } = Menu;
const { Sider, Content } = Layout;


export class Morpheus extends Component{
    
    constructor(props) {
        super(props);
        
        this.isMobile= cookie.load('isMobile') === 'true';

        this.state = {
            collapsed: this.isMobile ? true : false,
          };
    }

    toggle = () => {
        if (this.props.drawerCollapsed) {
            this.props.dispatch(openDrawer());
        } else {
            this.props.dispatch(closeDrawer());
        }
    };

    onCollapse = collapsed => {
        if (collapsed) {
            this.props.dispatch(closeDrawer());
        } else {
            this.props.dispatch(openDrawer());
        }
    };

    logout = () => {
        this.props.dispatch(logout());
    };

    goToAdminMode = () => {
        window.location.href =
          urls.current + "/admin";
    }

    render(){

        let sideMenuContent = getSideMenu(this.props.drawerCollapsed, this.toggle, this.logout, this.goToAdminMode);
        let sideMenu = null;
        let mobileHeader = null;

        if (this.isMobile) {
            mobileHeader = <Row className="mobile-header">
                <Col span={24}>
                    <img className="logo-mobile" src={logo_full} onClick={() => historyMP.push('/' + globalUrlPrefix + '/dashboard')}/>
                    <Row className="login-user-row">
                        <span className="login-user-prefix">Logged in as </span>
                            <br></br>
                        <span className="login-user">{cookie.load('first_name')}</span>
                        <br></br>
                        <Button key="7" onClick={this.logout}>
                            <Icon type="logout" />
                            <span>Logout</span>
                        </Button>
                    </Row>
                </Col>
            </Row>
        } else {
            sideMenu = <Sider className="sider" collapsed={this.props.drawerCollapsed} onCollapse={this.onCollapse}>
                {sideMenuContent}
            </Sider>
        }

        return(
            <Spin spinning={this.props.uiBusy} tip={this.props.busyMessage}>
                <Layout id="outer-container">
                    {sideMenu}
                    <Layout className="main-content">
                    {mobileHeader}
                    <Content id="content">
                        <PrivateRoute path={"/" + globalUrlPrefix + "/dashboard"} component={AllScansView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/scanners/:id/:progress_stage?"} component={ScannerView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/tuning/:id/"} component={TuningView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/sync/"} component={SyncViewerView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/case/:id"} component={CaseView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/categories/"} component={CategoryView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/category/:id/"} component={CaseListView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/classifier/:id/:spectype/:subtype/"} component={ClassifierUI} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/tuning/:id/"} component={TuningView} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/oldviewer/:id/"} component={OldScan} />
                        <PrivateRoute path={"/" + globalUrlPrefix + "/stats"} component={StatsDashboard} />
                    </Content>
                    </Layout>
                </Layout>
            </Spin>
        )
    }
}

function getSideMenu(collapsed, toggleHandler, logout, goToAdminMode) {

    let adminComponent = (cookie.load('morpheus_setting') || {}).show_case_view ? 
        [<Menu.Item key="9">
            <Link to={'/' + globalUrlPrefix + '/categories'}>
                <Icon type="book" />
                <span>Cases</span>
            </Link>
        </Menu.Item>] : [];

    let offlineComponent =  cookie.loadAll().deployment_mode === 'offline' ? 
        [
        <ScannersListComp/>, ...adminComponent
        ] : undefined;

    let askForSyncCode = () => {
        Modal.confirm({
          title: 'Please enter the code shared by the presenter',
          icon: <Icon type="info-circle"></Icon>,
          content: (
              <Input placeholder="Enter code here" id="sync-code" />
          ),
          onOk() {
            var code = document.getElementById("sync-code").value;
            var slideId = code.split('-')[0];
            var syncCode = code.split('-')[1];
            historyMP.push('/' + globalUrlPrefix + '/viewer/' + slideId + '?presentCode=' + syncCode);
          },
          onCancel() {}
        });
    }

    return (
        <Affix>
        <Row>
            {collapsed ? <img className="logo-square" src={logo_square} onClick={() => historyMP.push('/' + globalUrlPrefix + '/dashboard')}/> :
            <img className="logo" src={logo_full} onClick={() => historyMP.push('/' + globalUrlPrefix + '/dashboard')}/>}
        </Row>
        <Row className="login-user-row">
            <span className="login-user-prefix">Logged in as </span>
                <br></br>
            <span className="login-user">{cookie.load('first_name')}</span>
        </Row>
        <Row>
            <Menu 
                mode="inline" 
                defaultOpenKeys={['scanners']}
                defaultSelectedKeys={['dashboard']}
                className={"side-menu " + (collapsed ? '': 'side-menu-border')}>
                <Menu.Item key="0" onClick={toggleHandler}>
                <b><Icon type={collapsed ? "double-right" : "double-left"}/>
                    {collapsed ? "" : "Collapse Menu"}</b>
                </Menu.Item>
                <Menu.Item key="dashboard">
                    <Link to={'/' + globalUrlPrefix + '/dashboard'}>
                        <Icon type="profile" />
                        <span>Dashboard</span>
                    </Link>
                </Menu.Item>
                {cookie.loadAll().superuser === 'true' ?
                    <Menu.Item key="stats">
                        <Link to={'/' + globalUrlPrefix + '/stats'}>
                            <Icon type="bar-chart" />
                            <span>Stats Dashboard</span>
                        </Link>
                    </Menu.Item> : undefined }
                {offlineComponent}
                {cookie.load('first_name') === "Web Demo" ? undefined :
                    [ <Menu.Item key="3">
                        <Link to={'/' + globalUrlPrefix + '/sync'}>
                            <Icon type="sync" />
                            <span>Sync Mode</span>
                        </Link>
                    </Menu.Item>, 
                    <Menu.Item key="8" onClick={askForSyncCode}>
                        <Icon type="share-alt" />
                        <span>Join Slide Share</span>
                    </Menu.Item> ]}
                {cookie.loadAll().is_staff === 'true' ?
                <Menu.Item key="4" onClick={goToAdminMode}>
                    <Icon type="setting" />
                    <span>Admin Mode</span>
                </Menu.Item> : undefined }
                <Menu.Item key="7" onClick={logout}>
                    <Icon type="logout" />
                    <span>Logout</span>
                </Menu.Item>
            </Menu>
        </Row>
        </Affix>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        drawerCollapsed: state.dashboardReducer.drawerCollapsed, 
        uiBusy: state.utilsReducer.uiBusy, 
        busyMessage: state.utilsReducer.busyMessage
    };
};

export default connect(mapStateToProps)(Morpheus);
